"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _defineProperty = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _Object$freeze;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NetworkConnector = exports.RPC_URLS = void 0;

var schemas_1 = require("@dcl/schemas");

var network_connector_1 = require("@web3-react/network-connector");

exports.RPC_URLS = Object.freeze((_Object$freeze = {}, _defineProperty(_Object$freeze, schemas_1.ChainId.ETHEREUM_MAINNET, 'https://mainnet.infura.io/v3/21ee2680fd58460ba96d2b3addd7c38c'), _defineProperty(_Object$freeze, schemas_1.ChainId.ETHEREUM_ROPSTEN, 'https://ropsten.infura.io/v3/21ee2680fd58460ba96d2b3addd7c38c'), _defineProperty(_Object$freeze, schemas_1.ChainId.ETHEREUM_RINKEBY, 'https://rinkeby.infura.io/v3/21ee2680fd58460ba96d2b3addd7c38c'), _defineProperty(_Object$freeze, schemas_1.ChainId.ETHEREUM_GOERLI, 'https://goerli.infura.io/v3/21ee2680fd58460ba96d2b3addd7c38c'), _defineProperty(_Object$freeze, schemas_1.ChainId.ETHEREUM_KOVAN, 'https://kovan.infura.io/v3/21ee2680fd58460ba96d2b3addd7c38c'), _defineProperty(_Object$freeze, schemas_1.ChainId.MATIC_MAINNET, 'https://rpc-mainnet.maticvigil.com/v1/aad675783e3f73a13efbf6e95338d6de7fd5c9b9'), _defineProperty(_Object$freeze, schemas_1.ChainId.MATIC_MUMBAI, 'https://rpc-mumbai.maticvigil.com/v1/aad675783e3f73a13efbf6e95338d6de7fd5c9b9'), _Object$freeze));

var NetworkConnector = /*#__PURE__*/function (_network_connector_1$) {
  _inherits(NetworkConnector, _network_connector_1$);

  function NetworkConnector(chainId) {
    _classCallCheck(this, NetworkConnector);

    return _possibleConstructorReturn(this, _getPrototypeOf(NetworkConnector).call(this, {
      urls: exports.RPC_URLS,
      defaultChainId: chainId
    }));
  }

  return NetworkConnector;
}(network_connector_1.NetworkConnector);

exports.NetworkConnector = NetworkConnector;